import { gql, useMutation, useQuery } from '@apollo/client'

import {
  CancelPreSaleLotteryMutation,
  CancelPreSaleLotteryMutationVariables,
  PaymentCreateDetailFragmentDoc,
  PreSaleLotteryApplicantDetailFragmentDoc,
  PreSaleLotteryApplicantQuery,
  PreSaleLotteryApplicantQueryVariables,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useMessage, useRouter } from '@/core'
import { useAnalytics } from '@/core/analytics'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { analytics } = useAnalytics()
  const { router, routerPages, generatePath } = useRouter<{
    preSaleId: string
  }>()
  const { showError } = useMessage()
  const { data, loading } = useQuery<
    PreSaleLotteryApplicantQuery,
    PreSaleLotteryApplicantQueryVariables
  >(QUERY, {
    variables: {
      preSaleId: router.query.preSaleId,
    },
  })

  const [cancelPreSaleLottery, { loading: submittingCancel }] = useMutation<
    CancelPreSaleLotteryMutation,
    CancelPreSaleLotteryMutationVariables
  >(CANCEL_PRE_SALE_LOTTERY, {
    variables: {
      inputs: {
        preSaleId: router.query.preSaleId,
      },
    },
  })

  return {
    state: {
      loading,
      preSaleLotteryApplicant: data?.preSaleLotteryApplicant,
      paymentSource: data?.paymentSource ?? null,
      submittingCancel,
    },
    actions: {
      onCancelLaffleApplication: async () => {
        await analytics?.track('click_preSaleLotteryCancel', {
          applicationKey: config.applicationKey,
          preSaleId: router.query.preSaleId,
        })
        await cancelPreSaleLottery()
          .then(() => {
            router.push(
              generatePath(
                routerPages.LotteryApplicationDetailCancelCompletion,
                { preSaleId: router.query.preSaleId }
              )
            )
          })
          .catch(showError)
      },
    },
  }
})

const QUERY = gql`
  query PreSaleLotteryApplicant($preSaleId: String!) {
    preSaleLotteryApplicant(preSaleId: $preSaleId) {
      ...PreSaleLotteryApplicantDetail
    }
    paymentSource {
      ...paymentCreateDetail
    }
  }
  ${PreSaleLotteryApplicantDetailFragmentDoc}
  ${PaymentCreateDetailFragmentDoc}
`

const CANCEL_PRE_SALE_LOTTERY = gql`
  mutation CancelPreSaleLottery($inputs: CancelPreSaleLotteryInput!) {
    cancelPreSaleLottery(inputs: $inputs) {
      ...PreSaleLotteryApplicantDetail
    }
  }
  ${PreSaleLotteryApplicantDetailFragmentDoc}
`
